(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 768px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearchInstances = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearchInstances].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);

      this.mobileSearch = this.mobileSearch || this.header.querySelector('.orkide-mobile-search');
      if (this.mobileSearch) this.mobileSearch.open = false;

      this.predictiveSearchInstances = this.predictiveSearchInstances || this.querySelectorAll('predictive-search');
      this.predictiveSearchInstances.forEach((predictiveSearch) => predictiveSearch.close?.());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const initOrkideMobileSearch = (scope = document) => {
    scope.querySelectorAll('.orkide-mobile-search').forEach((mobileSearch) => {
      if (mobileSearch.dataset.initialized === 'true') return;
      mobileSearch.dataset.initialized = 'true';

      mobileSearch.addEventListener('toggle', () => {
        if (!mobileSearch.open) return;

        requestAnimationFrame(() => {
          mobileSearch.querySelector('input[type="search"]')?.focus();
        });
      });

      document.addEventListener('click', (event) => {
        if (mobileSearch.open && !mobileSearch.contains(event.target)) {
          mobileSearch.open = false;
        }
      });
    });
  };

  initOrkideMobileSearch();
  document.addEventListener('shopify:section:load', (event) => initOrkideMobileSearch(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slideshow')) {
    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.orkide-hs__slide'));
        this.dots = Array.from(this.querySelectorAll('.orkide-hs__dot'));
        this.index = 0;
        this.timer = null;
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (this.slides.length < 2) return;

        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => {
            this.goTo(i);
            this.restart();
          });
        });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        this.touchStartX = null;
        this.addEventListener('touchstart', (e) => {
          this.touchStartX = e.touches[0].clientX;
        }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (this.touchStartX === null) return;
          const dx = e.changedTouches[0].clientX - this.touchStartX;
          this.touchStartX = null;
          if (Math.abs(dx) > 40) {
            this.goTo(this.index + (dx < 0 ? 1 : -1));
            this.restart();
          }
        }, { passive: true });

        document.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.indexOf(e.target);
          if (i >= 0) {
            this.goTo(i);
            this.stop();
          }
        });
        document.addEventListener('shopify:block:deselect', (e) => {
          if (this.slides.includes(e.target)) this.start();
        });

        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      goTo(i) {
        const next = (i + this.slides.length) % this.slides.length;
        this.slides[this.index].classList.remove('is-active');
        this.slides[this.index].setAttribute('aria-hidden', 'true');
        this.slides[this.index].querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
        this.dots[this.index].classList.remove('is-active');
        this.dots[this.index].setAttribute('aria-selected', 'false');

        this.index = next;

        this.slides[this.index].classList.add('is-active');
        this.slides[this.index].removeAttribute('aria-hidden');
        this.slides[this.index].querySelectorAll('a').forEach((a) => a.removeAttribute('tabindex'));
        this.dots[this.index].classList.add('is-active');
        this.dots[this.index].setAttribute('aria-selected', 'true');
      }

      start() {
        if (this.reducedMotion.matches) return;
        if (this.timer) return;
        this.timer = setInterval(() => this.goTo(this.index + 1), this.speed);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }
    }

    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orkide-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function OrkideReviewsSlider(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    var track       = root.querySelector('.orkide-reviews__track');
    var viewport    = root.querySelector('.orkide-reviews__viewport');
    var slides      = Array.from(root.querySelectorAll('.orkide-review-card'));
    var dots        = Array.from(root.querySelectorAll('.orkide-reviews__dot'));
    var prevBtn     = root.querySelector('.orkide-reviews__arrow--prev');
    var nextBtn     = root.querySelector('.orkide-reviews__arrow--next');
    var total       = slides.length;
    var current     = 0;
    var timer       = null;
    var autoplayDelay = parseInt(root.dataset.autoplayDelay || '5000', 10);
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var tabletQuery = window.matchMedia('(max-width: 989px)');

    if (!track || total < 1) return;

    /* ── helpers ── */
    function perPage() {
      if (mobileQuery.matches) return 1;
      if (tabletQuery.matches) return 2;
      return 3;
    }

    function maxIndex() {
      return Math.max(0, total - perPage());
    }

    function clamp(n) {
      return Math.max(0, Math.min(n, maxIndex()));
    }

    function getGap() {
      var trackStyles = window.getComputedStyle(track);
      var gap = parseFloat(trackStyles.columnGap || trackStyles.gap || '0');
      return Number.isNaN(gap) ? 0 : gap;
    }

    function syncSlideHeights() {
      var tallest = 0;

      slides.forEach(function (slide) {
        slide.style.minHeight = '';
      });

      slides.forEach(function (slide) {
        tallest = Math.max(tallest, slide.offsetHeight);
      });

      if (!tallest) return;

      slides.forEach(function (slide) {
        slide.style.minHeight = tallest + 'px';
      });
    }

    function setActiveStates() {
      var pp = perPage();
      var visibleDots = maxIndex() + 1;

      slides.forEach(function (s, i) {
        var visible = i >= current && i < current + pp;
        s.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });

      dots.forEach(function (d, i) {
        var inRange = i < visibleDots;
        var active = inRange && i === current;

        d.hidden = !inRange;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current >= maxIndex();
    }

    function goTo(index, restartTimer) {
      current = clamp(index);
      var slideWidth = slides[0].getBoundingClientRect().width;
      var offset = current * (slideWidth + getGap());

      track.style.transform = 'translateX(-' + offset + 'px)';
      setActiveStates();
      if (restartTimer) startAutoplay();
    }

    /* ── autoplay ── */
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function startAutoplay() {
      stopAutoplay();
      if (total <= perPage()) return;
      timer = setInterval(function () {
        var next = current + 1;
        if (next > maxIndex()) next = 0;
        goTo(next, false);
      }, autoplayDelay);
    }

    /* ── events ── */
    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goTo(current - 1, true); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goTo(current + 1, true); });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10), true);
      });
    });

    /* Touch swipe */
    var touchStartX = 0;
    viewport.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
      stopAutoplay();
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(current + (diff > 0 ? 1 : -1), true);
      else startAutoplay();
    }, { passive: true });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    /* Keyboard */
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { goTo(current - 1, true); e.preventDefault(); }
      if (e.key === 'ArrowRight') { goTo(current + 1, true); e.preventDefault(); }
    });

    /* Resize — recalculate when viewport changes */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        syncSlideHeights();
        current = clamp(current);
        goTo(current, false);
      }, 150);
    }, { passive: true });

    /* Page visibility */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay(); else startAutoplay();
    });

    /* ── init ── */
    syncSlideHeights();
    goTo(0, false);
    startAutoplay();
  }

  /* Init all sliders on page */
  function initAll() {
    document.querySelectorAll('[data-orkide-slider]').forEach(function (el) {
      OrkideReviewsSlider(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
